import { render, staticRenderFns } from "./OrderSevenTrend.vue?vue&type=template&id=352f89da&scoped=true"
import script from "./OrderSevenTrend.vue?vue&type=script&lang=js"
export * from "./OrderSevenTrend.vue?vue&type=script&lang=js"
import style0 from "./OrderSevenTrend.vue?vue&type=style&index=0&id=352f89da&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f89da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352f89da')) {
      api.createRecord('352f89da', component.options)
    } else {
      api.reload('352f89da', component.options)
    }
    module.hot.accept("./OrderSevenTrend.vue?vue&type=template&id=352f89da&scoped=true", function () {
      api.rerender('352f89da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/OrderSevenTrend.vue"
export default component.exports